import React from "react"
import { FastField } from "formik"
import FormError from "../components/formError"

const CustomSelectInput = ({
  label,
  name,
  options,
  touched,
  errors,
  labelKey,
  valueKey,
  additionalClasses = "",
}) => {
  return (
    <div className={`form-group ${additionalClasses}`}>
      <label htmlFor={name}>{label}</label>
      <FastField
        className={`form-control custom-select mb-4`}
        as="select"
        id={name}
        name={name}
      >
        <options value="">Select {label}</options>
        {options.map((data, index) => (
          <option key={index} value={data[valueKey]}>
            {data[labelKey]}
          </option>
        ))}
      </FastField>
      <FormError touched={touched[name]} message={errors[name]} />
    </div>
  )
}
export default CustomSelectInput
